enum Mutations {
  SET_TIMEFRAME = 'setTimeframe',
  SET_IS_LOADING = 'setIsLoading',
}

export default Mutations;
